import { render, staticRenderFns } from "./agreementList.vue?vue&type=template&id=89d6fc52&scoped=true&"
import script from "./agreementList.vue?vue&type=script&lang=js&"
export * from "./agreementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d6fc52",
  null
  
)

export default component.exports